import CabinetChampionships from '@/apps/CabinetChampionships'
import Layout from '@/apps/layout/components'
import CabinetLayout from '@/apps/layout/components/CabinetLayout'
import React from 'react'

const CabinetChampionshipsPage = (): React.ReactElement => {
  return (
    <Layout>
      <CabinetLayout>
        <CabinetChampionships />
      </CabinetLayout>
    </Layout>
  )
}

export default CabinetChampionshipsPage
